var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewpdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1667 4.33325H13.0001C11.8508 4.33325 10.7486 4.7898 9.93595 5.60246C9.12329 6.41511 8.66675 7.51731 8.66675 8.66659V43.3333C8.66675 44.4825 9.12329 45.5847 9.93595 46.3974C10.7486 47.21 11.8508 47.6666 13.0001 47.6666H39.0001C40.1494 47.6666 41.2515 47.21 42.0642 46.3974C42.8769 45.5847 43.3334 44.4825 43.3334 43.3333V19.4999M28.1667 4.33325L43.3334 19.4999M28.1667 4.33325L28.1667 19.4999H43.3334",
    stroke: "#414142",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewpdf);
export default __webpack_public_path__ + "static/media/newpdf.270b8a26bebc42aa4d3268e51583c7f8.svg";
export { ForwardRef as ReactComponent };